import { sva } from '@allenai/varnish-panda-runtime/css';
import type { RecipeVariantProps } from '@allenai/varnish-panda-runtime/types';

const errorBoundaryRecipe = sva({
    slots: ['root', 'errorSection'],
    base: {
        root: {
            height: '[100vh]',
            backgroundColor: 'background.opacity-10.reversed',
            display: 'grid',
            placeItems: 'center',
            color: 'text.reversed',
            padding: '[16px]',
        },
        errorSection: {
            backgroundColor: 'background.opacity-100.reversed',
            maxWidth: '[100%]',
            width: '[fit-content]',
            margin: 'auto',
            padding: '[16px]',
            minHeight: '[50%]',
            maxHeight: '[90%]',
            overflowY: 'auto',
            border: '2px solid {colors.elements.error.fill}',
        },
    },
});

type ErrorBoundaryRecipeProps = RecipeVariantProps<typeof errorBoundaryRecipe>;

export { errorBoundaryRecipe, errorBoundaryRecipe as default };
export type { ErrorBoundaryRecipeProps };
